class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      buttons: this.querySelectorAll('.disclosure__item')
    };

    this.elements.buttons.forEach(button => {
      button.addEventListener('click', this.onItemClick.bind(this));
    });
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm); 